export var dataCarrierVersionTranslations = {
    "": { id: "ui-br-publishers.publishers.select.label.default" },
    CD_ROM: {
        id: "ui-br-publishers.publishers.workSpec.select.label.dataCarrierVersion.cd",
    },
    DVD_ROM: {
        id: "ui-br-publishers.publishers.workSpec.select.label.dataCarrierVersion.dvd",
    },
    "CD-ROM": {
        id: "ui-br-publishers.publishers.workSpec.select.label.dataCarrierVersion.cd",
    },
    "DVD-ROM": {
        id: "ui-br-publishers.publishers.workSpec.select.label.dataCarrierVersion.dvd",
    },
};
export var getDataCarrierVersionTranslations = function (intl, key) {
    var translation = dataCarrierVersionTranslations[key];
    if (!translation)
        return key;
    return intl.formatMessage(translation);
};
